import React from 'react';
import { useParams } from 'react-router-dom';

import { Text, Box, Title, Button, createStyles, Group } from '@mantine/core';

const RequestSubmitted = () => {
  const { ticketId } = useParams();

  const useStyles = createStyles((theme) => ({
    root: {
      paddingTop: 80,
      paddingBottom: 80,
    },

    label: {
      textAlign: 'center',
      fontWeight: 900,
      fontSize: 220,
      lineHeight: 1,
      marginBottom: theme.spacing.xl * 1.5,
      color: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],

      [theme.fn.smallerThan('sm')]: {
        fontSize: 120,
      },
    },

    title: {
      fontFamily: `Greycliff CF, ${theme.fontFamily}`,
      textAlign: 'center',
      fontWeight: 900,
      fontSize: 38,

      [theme.fn.smallerThan('sm')]: {
        fontSize: 32,
      },
    },

    description: {
      maxWidth: 500,
      margin: 'auto',
      marginTop: theme.spacing.xl,
    },
  }));

  const { classes } = useStyles();
  return (
    <Box>
      <Title my="xl" className={classes.title} order={3}>
        Request Submitted
      </Title>
      <Text className={classes.description}>Your request has been successfully submitted, and your Ticket ID is:</Text>{' '}
      <Text align="center" weight={700}>
        {ticketId}
      </Text>
      <Group position="center">
        <Button
          color="blue"
          variant="subtle"
          size="md"
          my="md"
          component="a"
          href={`https://servicedesk.ourepic.ca/WorkOrder.do?woMode=viewWO&woID=${ticketId}&PORTALID=1`}
        >
          View Ticket
        </Button>
      </Group>
      <Text className={classes.description} align="center" size="sm">
        Please note that you must be on a computer on the Lakeridge network to view your ticket.
      </Text>
    </Box>
  );
};

export default RequestSubmitted;
